module.exports = __webpack_public_path__ + "img/i-cursor.9573c0bb.svg";